<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    TIPO DE MOVIMENTO -
                    <b-badge variant="warning">{{ operacao }}</b-badge>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label
                                >Cód. Movimento <small>(CODTMV)</small></label
                            >
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="codMov"
                                    :disabled="
                                        desabilitarForm || desabilitarCodMov
                                    "
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Coligada <small>(CODCOLIGADA)</small></label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="codColigada"
                                    :disabled="desabilitarForm"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Filial <small>(CODFILIAL)</small></label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="codFilial"
                                    :disabled="desabilitarForm"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Local Estoque <small>(CODLOC)</small></label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="codLoc"
                                    :disabled="desabilitarForm"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label
                                >Vendedor
                                <small>(CODVEN1/CODVEN3)</small></label
                            >
                            <b-form-select
                                :options="vendedores"
                                v-model="codVen"
                                text-field="nome"
                                value-field="codigo"
                                :disabled="desabilitarForm"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label>Conta <small>(CODCXA)</small></label>
                            <b-form-select
                                :options="contas"
                                v-model="codCxa"
                                text-field="descricao"
                                value-field="codCxa"
                                :disabled="desabilitarForm"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label
                                >Condição de Pagamento
                                <small>(CODCPG)</small></label
                            >
                            <b-form-select
                                :options="condicoesPagamentos"
                                v-model="codCpg"
                                text-field="nome"
                                value-field="codigo"
                                :disabled="desabilitarForm"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label
                                >Tipo de Pagamento
                                <small>(CODTB2FLX)</small></label
                            >
                            <b-form-select
                                :options="classificacoesTb2Flx"
                                v-model="codTb2Flx"
                                text-field="descricao"
                                value-field="codTb2Flx"
                                :disabled="desabilitarForm"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Unidade <small>(CODUND)</small></label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="codUnd"
                                    :disabled="desabilitarForm"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label
                                >Orçamento
                                <small>(CODTBORCAMENTO)</small></label
                            >
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="codTbOrcamento"
                                    :disabled="desabilitarForm"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div v-if="codMov">
                    <h5 class="heading-1 mb-4">
                        <span>Arquivos XML</span>
                    </h5>
                    <ul class="list-group">
                        <li
                            class="list-group-item"
                            v-for="arquivo in arquivosXml"
                            :key="arquivo"
                        >
                            <btn-inserir-documento
                                :documento="{ codMov: codMov, tipo: arquivo }"
                            ></btn-inserir-documento>
                            <btn-download-documento
                                v-if="operacao == 'DETALHAR'"
                                :documento="{ codMov: codMov, tipo: arquivo }"
                            ></btn-download-documento>
                            {{ arquivo }} <br />
                            Campos de substituição automática:
                            <span
                                v-for="(campo, index) in camposAutomaticos(
                                    arquivo
                                )"
                                :key="campo"
                                ><span v-if="index > 0"> | </span
                                >{{ campo }}</span
                            >
                        </li>
                    </ul>
                </div>
            </b-card-body>
            <b-card-footer>
                <btn-salvar
                    class="float-left mr-2"
                    :operacao="operacao"
                    :tipoMovimento="tipoMovimento"
                    :desabilitarSalvar="$v.$invalid"
                    @atualizarErros="erros = $event"
                    @obterTiposMovimentosAtualizados="obterTiposMovimentos()"
                >
                </btn-salvar>
                <app-btn-voltar class="float-left"></app-btn-voltar>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import TiposMovimentosServicos from './TiposMovimentosServicos'
import BtnSalvar from './BtnSalvar'
import BtnInserirDocumento from './BtnInserirDocumento'
import BtnDownloadDocumento from './BtnDownloadDocumento'

export default {
    components: {
        BtnSalvar,
        BtnInserirDocumento,
        BtnDownloadDocumento
    },

    props: {},

    data() {
        return {
            erros: [],
            codMov: '',
            codColigada: '',
            codFilial: '',
            codVen: null,
            codLoc: null,
            codCxa: null,
            codCpg: null,
            codTb2Flx: null,
            codUnd: null,
            codTbOrcamento: null,
            vendedores: [],
            contas: [],
            condicoesPagamentos: [],
            classificacoesTb2Flx: [],
            arquivosXml: [
                'TMOV',
                'TMOVCOMPL',
                'TMOVHISTORICO',
                'TITMMOV',
                'TITMMOVRATCCU'
            ],
            camposAutomaticosTMOV: [
                'CHAVEORIGEM',
                'OPERACAO',
                'STATUS',
                'CAMPOLIVRE1',
                'CODCOLCFO',
                'CODCFO',
                'DATAEMISSAO',
                'DATASAIDA',
                'DATAEXTRA1',
                'DATALANCAMENTO',
                'CODETDMUNSERV',
                'CODMUNSERVICO',
                'IDNAT',
                'CODCOLCXA',
                'NUMEROMOV'
            ],
            camposAutomaticosTMOVCOMPL: [
                'CHAVEORIGEM',
                'OPERACAO',
                'STATUS',
                'ENQUADRAMENTO',
                'MODALIDADE'
            ],
            camposAutomaticosTMOVHISTORICO: [
                'CHAVEORIGEM',
                'OPERACAO',
                'STATUS',
                'HISTORICOCURTO',
                'HISTORICOLONGO'
            ],
            camposAutomaticosTITMMOV: [
                'NSEQITMCNT',
                'IDCNT',
                'CHAVEORIGEM',
                'OPERACAO',
                'STATUS',
                'NSEQITMMOV',
                'IDPRD',
                'QUANTIDADE',
                'PRECOUNITARIO'
            ],
            camposAutomaticosTITMMOVRATCCU: [
                'CHAVEORIGEM',
                'OPERACAO',
                'STATUS',
                'NSEQITMMOV',
                'CODCCUSTO',
                'VALOR',
                'PERCENTUAL'
            ]
        }
    },

    methods: {
        obterDados() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.obterDados().then(response => {
                if (response) {
                    if (response.success) {
                        this.preencherFormulario(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter vendedores',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterTipoMovimento() {
            this.$store.dispatch('addRequest')
            TiposMovimentosServicos.obterTipoMovimento(
                this.$route.params.codMov
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.preencherFormulario(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter vendedores',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencherFormulario(data) {
            this.vendedores = data.vendedores
            this.vendedores.unshift({ codigo: null, nome: '' })

            this.contas = data.contas
            this.contas.unshift({ codCxa: null, descricao: '' })

            this.condicoesPagamentos = data.condicoesPagamentos
            this.condicoesPagamentos.unshift({
                codigo: null,
                nome: ''
            })

            this.classificacoesTb2Flx = data.classificacoesTb2Flx
            this.classificacoesTb2Flx.unshift({
                codTb2Flx: null,
                descricao: ''
            })

            if (this.operacao == 'INSERIR') {
                this.codColigada = data.configuracaoPadrao.codColigada
                this.codFilial = data.configuracaoPadrao.codFilial
            } else if (this.operacao == 'DETALHAR') {
                this.codMov = data.codMov
                this.codColigada = this.obterValorCampo(
                    data.detalhes,
                    'CODCOLIGADA'
                )
                this.codFilial = this.obterValorCampo(
                    data.detalhes,
                    'CODFILIAL'
                )
                this.codVen = this.obterValorCampo(data.detalhes, 'CODVEN')
                this.codCxa = this.obterValorCampo(data.detalhes, 'CODCXA')
                this.codCpg = this.obterValorCampo(data.detalhes, 'CODCPG')
                this.codTb2Flx = this.obterValorCampo(
                    data.detalhes,
                    'CODTB2FLX'
                )
                this.codUnd = this.obterValorCampo(data.detalhes, 'CODUND')
                this.codTbOrcamento = this.obterValorCampo(
                    data.detalhes,
                    'CODTBORCAMENTO'
                )
                this.codLoc = this.obterValorCampo(data.detalhes, 'CODLOC')
            }
        },

        obterValorCampo(detalhes, valor) {
            let detalhe = detalhes.find(p => p.campo == valor)
            return detalhe ? detalhe.valor : null
        },

        obterTiposMovimentos() {
            this.$emit('obterTiposMovimentos')
            this.$router.push({
                name: 'TiposMovimentos'
            })
        },

        camposAutomaticos(tipo) {
            switch (tipo) {
                case 'TMOV':
                    return this.camposAutomaticosTMOV
                    break
                case 'TMOVCOMPL':
                    return this.camposAutomaticosTMOVCOMPL
                    break
                case 'TMOVHISTORICO':
                    return this.camposAutomaticosTMOVHISTORICO
                    break
                case 'TITMMOV':
                    return this.camposAutomaticosTITMMOV
                    break
                case 'TITMMOVRATCCU':
                    return this.camposAutomaticosTITMMOVRATCCU
                    break
                default:
                    return []
                    break
            }
        }
    },

    created() {
        if (this.operacao == 'INSERIR') {
            this.obterDados()
        } else if (this.operacao == 'DETALHAR') {
            this.obterTipoMovimento()
        }
    },

    computed: {
        operacao() {
            if (this.$route.name == 'TiposMovimentos_Inserir') {
                return 'INSERIR'
            } else if (this.$route.name == 'TiposMovimentos_Detalhar') {
                return 'DETALHAR'
            }
        },

        desabilitarForm() {
            return false
        },

        desabilitarCodMov() {
            return this.operacao == 'DETALHAR'
        },

        tipoMovimento() {
            return {
                codMov: this.codMov,
                codColigada: this.codColigada,
                codFilial: this.codFilial,
                codVen: this.codVen,
                codLoc: this.codLoc,
                codCxa: this.codCxa,
                codCpg: this.codCpg,
                codTb2Flx: this.codTb2Flx,
                codUnd: this.codUnd,
                codTbOrcamento: this.codTbOrcamento
            }
        }
    },

    watch: {},

    validations: {
        codMov: {
            required
        },
        codColigada: {
            required
        },
        codFilial: {
            required
        },
        codLoc: {
            required
        }
    }
}
</script>
